import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Domaine canonique (ex. dojova.com) : redirige les anciens domaines (kaizenfranchise.com) en conservant le chemin. Inactif si non configuré.
const CANONICAL = (process.env.REACT_APP_CANONICAL_HOST || "").trim().toLowerCase();
const host = window.location.hostname.toLowerCase();
if (CANONICAL && host !== CANONICAL && !host.endsWith("emergentagent.com") && host !== "localhost" && !/^\d+\.\d+\.\d+\.\d+$/.test(host)) {
  window.location.replace(`https://${CANONICAL}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => null));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
